import config from "../../setup/config";
import "../../setup/js/_toggleClass";
import "../../setup/js/_scaleRoot.2";
import "@fancyapps/fancybox";
import "../../setup/js/_swiper";
//import "../../setup/js/_scrollwatch";
//import scrollFrame from "../../setup/js/_scrollFrame";
import "lazysizes";

$(function () {
  var isIOS = ( navigator.userAgent.match(/(iPad|iPhone|iPod)/i) ? true : false );
  var isANDROID = navigator.userAgent.toLowerCase().indexOf("android") > -1; 
  commonLibs();

  // if (isIOS) {
  //   $(".appinfo_download_ios").show();
  //   $(".appinfo_download_ggplay").hide();
  // }
  // if (isANDROID){
  //   $(".appinfo_download_ios").hide();
  //   $(".appinfo_download_ggplay").show();
  // }
  // INIT SWIPER

  if ($("#swiperFeature").length > 0) {
    var slideTotal = 0,
      slideCurrent = 0;
    $("#swiperFeature").initSwiper({
      isRenderBullet: true,
      swiperOptions: {
        slidesPerView: "auto",
        centeredSlides: true,
        loop: true,
        //spaceBetween: 0,
        effect: "coverflow",
        coverflowEffect: {
          rotate: 0,
          //   stretch: 438,
          stretch: 224,
          depth: 130,
          modifier: 1,
          slideShadows: false,
        },
        lazy: {
          loadPrevNext: true,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true, // Clickable pagination dots
        },
        autoplay: {
          delay: 5000,
        },
        breakpoints: {
          769: {
            slidesPerView: "auto",
            effect: "coverflow",
            coverflowEffect: {
              stretch: 593,
              depth: 255,
            },
          },
        },
      },
    });
  }
});

window.addEventListener("load", function () {
  //When load all assets (style, images,...)

  $(window)
    .on("resize", function () {
      $("#wrapper").scalePlatform();
    })
    .resize();
  // Add global functions here
  $("#loading").each(function () {
    $("#loading").removeClass("active");
  });
});

var commonLibs = function () {
  $("#wrapper").scalePlatform();
};
